module.exports = __webpack_public_path__ + "static/media/cate-tech.eefd7487.png";